import * as React from "react";
const IconInstagram = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 25}
    height={props.height ?? 25}
    fill="none"
    style={{ cursor: "pointer", ...props.style }}
    {...props}
  >
    <path
      fill={props.color1 ?? "#fff"}
      d="M15.264 22H6.736A6.743 6.743 0 0 1 0 15.265v-8.53A6.743 6.743 0 0 1 6.736 0h8.528A6.743 6.743 0 0 1 22 6.736v8.529A6.743 6.743 0 0 1 15.264 22ZM6.736 1.647a5.094 5.094 0 0 0-5.089 5.089v8.529a5.094 5.094 0 0 0 5.089 5.088h8.528a5.094 5.094 0 0 0 5.089-5.088v-8.53a5.094 5.094 0 0 0-5.089-5.088H6.736Z"
    />
    <path
      fill={props.color1 ?? "#fff"}
      d="M11 16.565A5.571 5.571 0 0 1 5.435 11 5.571 5.571 0 0 1 11 5.435 5.571 5.571 0 0 1 16.565 11 5.571 5.571 0 0 1 11 16.565Zm0-9.443A3.882 3.882 0 0 0 7.122 11 3.882 3.882 0 0 0 11 14.878 3.882 3.882 0 0 0 14.878 11 3.882 3.882 0 0 0 11 7.122ZM18.62 4.83a1.449 1.449 0 1 1-2.898 0 1.449 1.449 0 0 1 2.897 0Z"
    />
  </svg>
);
export default IconInstagram;
